var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstimatedTotalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.998047C16.524 0.998047 21.002 5.47605 21.002 11C21.002 16.523 16.524 21.001 11 21.001C5.47605 21.001 0.998047 16.523 0.998047 11C0.998047 5.47605 5.47605 0.998047 11 0.998047ZM10.996 9.24805C10.751 9.24838 10.5146 9.3387 10.3317 9.50184C10.1488 9.66499 10.0322 9.88961 10.004 10.133L9.99705 10.249L10 15.751L10.007 15.868C10.0352 16.1119 10.1522 16.3369 10.3355 16.5002C10.5189 16.6634 10.7559 16.7535 11.0014 16.7532C11.2469 16.753 11.4838 16.6624 11.6668 16.4988C11.8499 16.3352 11.9663 16.11 11.994 15.866L12 15.749L11.997 10.248L11.99 10.131C11.9611 9.88781 11.844 9.66363 11.6607 9.50106C11.4775 9.33848 11.241 9.24881 10.996 9.24905V9.24805ZM11 5.49905C10.6681 5.49905 10.3498 5.6309 10.1151 5.8656C9.8804 6.1003 9.74855 6.41863 9.74855 6.75055C9.74855 7.08247 9.8804 7.40079 10.1151 7.63549C10.3498 7.87019 10.6681 8.00205 11 8.00205C11.332 8.00205 11.6503 7.87019 11.885 7.63549C12.1197 7.40079 12.2515 7.08247 12.2515 6.75055C12.2515 6.41863 12.1197 6.1003 11.885 5.8656C11.6503 5.6309 11.332 5.49905 11 5.49905Z",
    fill: "#0090B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimatedTotalIcon);
export default __webpack_public_path__ + "static/media/estimated-total-icon.8952d760f7ab3924b57de7d15aa77ee7.svg";
export { ForwardRef as ReactComponent };